module.exports = __webpack_public_path__ + "img/Pink老师-1.e3230384.png";